import React from "react";
import Hletter from "../../assets/Hletter";
import "./styles.scss";
import { storySection } from "../../texts";
import { useEffect } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { gsap } from "gsap";

const Story = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    let hasPlayed = false;

    const animation = gsap
      .timeline({
        paused: true,
      })
      .to(".storyContainer", {
        opacity: 1,
        y: -100,
      });

    ScrollTrigger.create({
      trigger: "#story",
      start: "-10% 80%",
      end: "30% 90%",
      onEnter: () => {
        if (!hasPlayed) {
          animation.play();
          hasPlayed = true;
        }
      },
    });
  }, []);

  return (
    <section id="story" className="storySection">
      <div className="storyContainer">
        <div className="storyFlexContainer">
          <Hletter className="letter" />
          <div>
            <div className="subheader">{storySection.title1}</div>
            <div className="subheaderBigger">{storySection.title2}</div>
            <div className="textContainer">
              <p className="storyParagraph">
                {storySection.paragraph1}
                <br /> <br />
                {storySection.paragraph2}
                <br />
                <br />
                {storySection.paragraph3}
                <br></br>
                {storySection.paragraph4}
                <br></br>
                <br></br>
                {storySection.paragraph5}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
